import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from "axios";
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const MedSplInstrForm = (props) => {

    const initialFormData = {
        splinstr: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const formRef = useRef(null);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    //const navigate = useNavigate();

    useEffect(() => {
        async function setMedSplDetails() {
            //console.log("set edit details " + props.allergyvalue);
            const { instruction, is_active, instruction_id } = props.medsplvalue;
      
            setFormData({
              splinstr: instruction || "",
              isactive: is_active == 1 || is_active === true, // normalize boolean
              id: instruction_id || ""
            });

            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        }

        if (props.edittrigger > 0) {
            //console.log(props.trigger);
            setMedSplDetails();
        }
    }, [props.edittrigger]);

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsSplInstrUrl = buttonStatus == "Add" ? `${process.env.REACT_APP_SERVER_URL}` + "/prescriptions/add-prescription-instruction/" : `${process.env.REACT_APP_SERVER_URL}` + "/prescriptions/update-prescription-instruction/";
        let pelmedsSplInstrData = buttonStatus == "Add" ? { "instruction": formData.splinstr,"group_id" : localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0 } :
            { "instruction": formData.splinstr,"group_id" : localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "id": formData.id }

        //console.log("pelmedsSplInstrData" + JSON.stringify(pelmedsSplInstrData));

        const { data } = await axios.post(pelmedsSplInstrUrl, pelmedsSplInstrData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        console.log("Dat " + JSON.stringify(data));

        if (data.status) {
            toast.success("Special Instruction added/updated successfully");
            //navigate(0);
        }
        else {
            toast.info("Error while adding Special Instruction");
        }

        //if (buttonStatus != "Edit") {
        setFormData(initialFormData);
        formRef.current.reset();
        setButtonStatus("Add");
        //}

        props.onCallParent();
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Special Instruction</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            placeholder='Special Instruction Name'
                            value={formData.splinstr}
                            name="splinstr"
                            size="sm"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="mt-4 w-50"
                            size="sm"
                            disabled={!formData.splinstr}>
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={
                                formData.isactive
                            }
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};
export default MedSplInstrForm;
